<!-- 
	This is the Dashboards default page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>

    <div>

        <!-- Orders List header -->
        <a-row type="flex" :gutter="24">
            <a-col :span="12" class="mb-24">
                <label style="margin-right: 15px"><strong>Tanggal</strong></label>
                <a-dropdown :trigger="['click']">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        {{ filterDateText }}
                        <a-icon class="ml-5" type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                        <a-menu-item key="0" @click="setFilterTanggal('all')">Semua</a-menu-item>
                        <a-menu-item key="1" @click="setFilterTanggal('this_day')">Hari Ini</a-menu-item>
                        <a-menu-item key="2" @click="setFilterTanggal('this_week')">Minggu Ini</a-menu-item>
                        <a-menu-item key="3" @click="setFilterTanggal('this_month')">Bulan Ini</a-menu-item>
                        <a-menu-item key="4" disabled style="cursor: pointer">
                            <div style="color: #595959; margin-bottom: 5px">Tanggal</div>
                            <a-date-picker style="width: 140px" placeholder="Tanggal Awal" @change="setTanggalAwal"></a-date-picker>
                            <a-date-picker style="width: 140px; margin-left: 5px" placeholder="Tanggal Akhir" @change="setTanggalAkhir"></a-date-picker>
                        </a-menu-item>

                    </a-menu>
                </a-dropdown>

            </a-col>
            <a-col :span="12" class="mb-24">
                <label style="margin-right: 15px"><strong>Status</strong></label>
                <a-dropdown :trigger="['click']">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        {{ filterStatusMap[filterStatus] }}
                        <a-icon class="ml-5" type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                        <a-menu-item :key="0" @click="setFilterStatus('all')">Semua</a-menu-item>
                        <a-menu-item :key="i + 1" @click="setFilterStatus(status.code)" v-for="(status, i) in statusMap">{{ status.description }}</a-menu-item>
                    </a-menu>
                </a-dropdown>

            </a-col>
        </a-row>
        <!-- / Orders List header -->

        <!-- Orders List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">

            <div style="position: absolute; left: 10px; top: 10px; z-index: 10; display: flex">
                <a-button @click="getData()" class="no-shadow">
                    <a-icon type="reload"></a-icon>
                </a-button>

                <a-dropdown :trigger="['click']" class="ml-5 no-shadow">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        Per page {{ perPage }}
                        <a-icon class="ml-5" type="down"/>
                    </a-button>
                    <a-menu slot="overlay">
                        <a-menu-item :key="-1" @click="perPage = 5">5</a-menu-item>
                        <a-menu-item :key="0" @click="perPage = 10">10</a-menu-item>
                        <a-menu-item :key="1" @click="perPage = 20">20</a-menu-item>
                        <a-menu-item :key="2" @click="perPage = 50">50</a-menu-item>
                        <a-menu-item :key="3" @click="perPage = 100">100</a-menu-item>
                        <a-menu-item :key="4" @click="perPage = 200">200</a-menu-item>
                        <a-menu-item :key="5" @click="perPage = 500">500</a-menu-item>
                    </a-menu>
                </a-dropdown>

                <download-excel
                    class="ant-btn ant-btn-default ml-5 no-shadow"
                    style="display: flex; align-items: center"
                    :data="formattedData"
                    :fields="{
                        'No': 'no',
                        'Kode Booking': 'booking_code',
                        'Koas Utama': {
                            callback: (v) => v.koas_resident_name + ' (' + v.koas_resident_code + ')'
                        },
                        'Koas Partner': {
                            callback: (v) => v.koas_resident_name2 ? v.koas_resident_name2 + ' (' + v.koas_resident_code2 + ')' : ''
                        },
                        'DPJP': 'dpjp.name',
                        'Nama Pasien': 'patient_name',
                        'Klinik': 'departement.name',
                        'Tanggal/Jam': {
                            callback: (v) => formatTanggal(v)
                        },
                        'Status': {
                            callback: (row) => {
                                const ar = [statusByCode(row.trx_status)]

                                if (row.trx_status !== '5-done' && row.working_format_status) {
                                    ar.push('Format Kerja : ' + statusByCode(row.working_format_status))
                                }

                                if (row.partner_trx_status) {
                                    ar.push('Partner : ' + statusByCode(row.partner_trx_status))
                                }

                                return ar.join('\n')
                            }
                        },
                    }"
                    worksheet="My Worksheet"
                    name="filename.xls"
                >
                    Export Excel
                </download-excel>
            </div>

            <div style="position: absolute; left: 20px; bottom: 20px; z-index: 10">
                Total Data : <strong>{{ this.formattedData.length }}</strong>
            </div>

            <!-- Table search -->
            <div class="mx-25">
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" class="text-right">
                        <div style="position: relative">
                            <a-input placeholder="input search text" style="max-width: 200px;" v-model="query" allow-clear/>
                            <a-icon v-if="!query" style="position: absolute; right: 10px; top: 12px; color: rgba(0, 0, 0, 0.25)" type="search"></a-icon>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <!-- / Table search -->

            <!-- Orders table -->
            <a-table class="mt-20"
                     :columns="columns"
                     :data-source="formattedData"
                     :pagination="{pageSize: perPage}"
                     rowKey="no"
            >

                <template slot="id" slot-scope="no">#{{ no }}</template>

                <template slot="koas" slot-scope="row">
                    <div>
                        {{ row.koas_resident_name }}
                        <strong>
                            ({{ row.koas_resident_code }})
                        </strong>
                    </div>
                    <div v-if="row.koas_resident_name2">
                        {{ row.koas_resident_name2 }}
                        <strong>
                            ({{ row.koas_resident_code2 }})
                        </strong>
                    </div>
                </template>

                <template slot="tanggal" slot-scope="row">
                    {{ formatTanggal(row) }}
                </template>

                <template slot="status" slot-scope="row">
                    <div>
                        {{ statusByCode(row.trx_status) }}
                    </div>
                    <div v-if="row.trx_status !== '5-done' && row.working_format_status" class="mt-10">
                        <strong>Format Kerja</strong> : {{ statusByCode(row.working_format_status) }}
                    </div>
                    <div v-if="row.partner_trx_status" class="mt-10">
                        <strong>Partner</strong> : {{ statusByCode(row.partner_trx_status) }}
                    </div>
                </template>

                <template slot="aksi" slot-scope="row">
                    <a-dropdown :trigger="['click']" class="no-shadow">
                        <a-button>
                            <a-icon type="more"></a-icon>
                        </a-button>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item @click="toDetail(row)">Timeline</a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </template>

            </a-table>
            <!-- / Orders table -->

        </a-card>
        <!-- / Orders List card -->

    </div>

</template>

<script>

import BookingApi from "../../../repository/api/BookingApi";
import {dateFormatIndo, dateFormatIndoWithDay, dateOnlyHourMinute} from "../../../utils/Extenstion";
import SettingRepository from "../../../repository/SettingRepository";
import {BASE_URL_API} from "../../../utils/Config";

// Table columns
const columns = [
    {
        title: 'No',
        dataIndex: 'no',
        sorter: (a, b) => a.no - b.no,
        sortDirections: ['ascend', 'descend'],
        scopedSlots: { customRender: 'id'},
    },
    {
        title: 'Kode Booking',
        sorter: (a, b) => a.booking_code.localeCompare(b.booking_code),
        sortDirections: ['ascend', 'descend'],
        dataIndex: 'booking_code',
    },
    {
        title: 'Koas',
        sorter: (a, b) => a.koas_resident_name.localeCompare(b.koas_resident_name),
        sortDirections: ['ascend', 'descend'],
        scopedSlots: {customRender: 'koas'},
    },
    {
        title: 'DPJP',
        sorter: (a, b) => {
            if (!a.dpjp)
                return -1
            if (!b.dpjp)
                return 1

            return a.dpjp.name.localeCompare(b.dpjp.name)
        },
        sortDirections: ['ascend', 'descend'],
        dataIndex: 'dpjp.name',
    },
    {
        title: 'Nama Pasien',
        dataIndex: 'patient_name',
        sorter: (a, b) => a.patient_name.localeCompare(b.patient_name),
        sortDirections: ['ascend', 'descend'],
    },
    {
        title: 'Klinik',
        dataIndex: 'departement.name',
        sorter: (a, b) => {
            if (!a.departement)
                return -1
            if (!b.departement)
                return 1

            return a.departement.name.localeCompare(b.departement.name)
        },
        sortDirections: ['ascend', 'descend'],
    },
    {
        title: 'Tanggal / Jam',
        scopedSlots: {customRender: 'tanggal'},
        sorter: (a, b) => a.booking_date.localeCompare(b.booking_date),
        sortDirections: ['ascend', 'descend'],
    },
    {
        title: 'Status',
        scopedSlots: {customRender: 'status'},
    },
    {
        title: 'Aksi',
        scopedSlots: {customRender: 'aksi'},
    },
]

const searchables = [
    'booking_code',
    'koas_resident_code',
    'koas_resident_name',
    'koas_resident_code2',
    'koas_resident_name2',
    'dpjp.name',
    'patient_name',
    'departement.name',
]

export default {
    data() {
        return {
            columns,

            data: [],
            statusMap: [],
            filterStatusMap: {},

            filterDateText: SettingRepository.get("ListBookingKoas", "filterDateText") ?? 'Semua',
            filterDateValue: SettingRepository.get("ListBookingKoas", "filterDateValue") ?? 'all',
            filterDateStart: SettingRepository.get("ListBookingKoas", "filterDateStart") ?? '',
            filterDateEnd: SettingRepository.get("ListBookingKoas", "filterDateEnd") ?? '',
            filterStatus: SettingRepository.get("ListBookingKoas", "filterStatus") ?? 'all',
            query: SettingRepository.get("ListBookingKoas", "filterQuery") ?? '',
            perPage: SettingRepository.getInt("DashboardDokter", "perPage", 10),

            unsubscribeFcm: null,
        }
    },

    async mounted() {
        this.getStatus()
        this.getData()

        await this.$store.dispatch("apiData/getRefPenilaian")
    },

    computed: {
        formattedData() {
            return this.data.map((value, index) => ({
                ...value,
                no: index + 1
            })).filter(x => {
                if (!this.query) return true

                for (const col of searchables) {
                    const paths = col.split('.')
                    let val = x

                    for (const path of paths) {
                        val = val[path]

                        if (!val)
                            break
                    }

                    if (val && val.toLowerCase().includes(this.query.toLowerCase()))
                        return true
                }

                return false
            })
        },

        baseUrl() {
            return BASE_URL_API
        }
    },

    methods: {
        getStatus() {
            BookingApi.getStatus()
                .then((response) => {
                    this.statusMap = response

                    const m = { 'all': 'Semua' }

                    for (const s of this.statusMap) {
                        m[s.code] = s.description
                    }

                    this.filterStatusMap = m
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        getData() {
            const query = {
                date: this.filterDateValue,
                status: this.filterStatus,
                koas_resident_code: this.$store.getters['auth/user'].user.username,
            }

            BookingApi.getByQuery(query)
                .then((response) => {
                    this.data = response.sort((a, b) => {
                        return b.booking_date.localeCompare(a.booking_date)
                    })
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    });
                })
        },

        toDetail(row) {
            this.$router.push('/dashboards/dpjp/timeline/' + row.id)
        },

        setFilterTanggal(id) {
            this.filterDateValue = id
            const dateTexts = {
                'all': 'Semua',
                'this_day': 'Hari Ini',
                'this_week': 'Minggu Ini',
                'this_month': 'Bulan Ini',
            }

            this.filterDateText = dateTexts[id]
            this.getData()
        },

        setFilterStatus(id) {
            this.filterStatus = id
            this.getData()
        },

        setTanggalAwal(date, dateString) {
            this.filterDateStart = dateString
            this.setTanggal()
            this.getData()
        },

        setTanggalAkhir(date, dateString) {
            this.filterDateEnd = dateString
            this.setTanggal()
            this.getData()
        },

        setTanggal() {
            if (this.filterDateStart) {
                this.filterDateText = dateFormatIndo(this.filterDateStart)
                this.filterDateValue = this.filterDateStart

                if (this.filterDateEnd) {
                    this.filterDateText += ' - ' + dateFormatIndo(this.filterDateEnd)
                    this.filterDateValue += ' ' + this.filterDateEnd
                }
            }
            else {
                this.filterDateText = "Hari Ini"
                this.filterDateValue = "this_day"
            }
        },

        statusByCode(code) {
            if (code === 'all')
                return "Semua"

            const s = this.statusMap.find(x => x.code === code)
            return s ? s.description : '-'
        },

        formatTanggal(row) {
            return dateFormatIndoWithDay(row.booking_date) + ' ' + dateOnlyHourMinute(row.dental_unit_time)
        },
    },

    watch: {
        filterDateText: function (n, o) {
            SettingRepository.save("ListBookingKoas", "filterDateText", n)
        },

        filterDateValue: function (n, o) {
            SettingRepository.save("ListBookingKoas", "filterDateValue", n)
        },

        filterDateStart: function (n, o) {
            SettingRepository.save("ListBookingKoas", "filterDateStart", n)
        },

        filterDateEnd: function (n, o) {
            SettingRepository.save("ListBookingKoas", "filterDateEnd", n)
        },

        filterStatus: function (n, o) {
            SettingRepository.save("ListBookingKoas", "filterStatus", n)
        },

        query: function (n, o) {
            SettingRepository.save("ListBookingKoas", "filterQuery", n)
        },

        perPage: function (n, o) {
            SettingRepository.save("DashboardDokter", "perPage", n)
        },
    }
};
</script>

<style lang="scss" scoped>

.notif-badge {
    margin-left: 10px;
    background: #F5222D;
    color: white;
    padding: 4px;
    border-radius: 100px;
    font-size: 16px;
}

</style>
